"use client";

import React from "react";
import { Plus } from "lucide-react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
export default function Faq() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  const faqData = [{
    question: "Quels sont les coûts d'un audit énergétique ?",
    answer: "Le coût d'un audit énergétique varie généralement entre 800 € et 1 200 €, selon la complexité de votre logement et la surface à analyser. Ce montant peut être partiellement pris en charge par les aides de l'État comme MaPrimeRénov'."
  }, {
    question: "Quelles aides financières mobilisables pour les travaux de rénovation énergétique ?",
    answer: "MA PRIME RENOV' : dispositif phare de l'Etat, cette aide s'adresse à tous les propriétaires. Elle finance une part significative des travaux d'isolation, de chauffage et de ventilation, calculée selon vos revenus et le gain énergétique du projet. CEE (Certificat d'Economies d'Energies) : financée par les fournisseurs d'énergie, cette prime cumulable vient en complément de MaPrimeRénov', rendant les travaux de rénovation énergétique accessibles au plus grand nombre. ECO-PTZ : l'Eco-PTZ vous permet d'emprunter jusqu'à 50 000 € sans payer d'intérêts. Une solution idéale pour lisser l'investissement sur plusieurs années."
  }, {
    question: "Combien de temps dure un audit énergétique ?",
    answer: "La visite sur site dure généralement entre 3h et 4h pour relever toutes les informations nécessaires. Le rapport complet vous est ensuite remis sous 1 à 2 semaines après l'analyse des données."
  }, {
    question: "Quelle est la différence entre un DPE et un audit énergétique ?",
    answer: "Le DPE est une évaluation rapide de la performance énergétique d'un logement, obligatoire pour la vente ou la location. Il dit où vous en êtes. L'audit énergétique est une analyse beaucoup plus approfondie qui propose des scénarios de travaux précis et chiffrés pour atteindre une meilleure performance énergétique. Il dit quoi faire et pour combien. L'un est une photo l'autre est une feuille de route."
  }];
  return <section id="faq" className="bg-muted py-16 md:py-24">
      <div ref={ref} className={cn("container max-w-3xl mx-auto px-4 transition-all duration-700 ease-in-out", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8")}>
        <h2 className="text-3xl md:text-4xl font-bold text-primary mb-10 text-center font-sans">
          Questions Fréquentes
        </h2>

        <Accordion type="single" collapsible className="w-full">
          {faqData.map((item, i) => <AccordionItem key={i} value={`item-${i}`} data-index={i} className="border-secondary border-b last:border-b-0">
              <AccordionTrigger className="group [&>svg:last-child]:hidden hover:no-underline py-5 md:py-6">
                <span className="text-lg font-medium text-primary font-sans text-left pr-4">
                  {item.question}
                </span>
                <div className="shrink-0">
                  <Plus className="size-5 text-primary transition-transform duration-300 group-data-[state=open]:rotate-45" />
                </div>
              </AccordionTrigger>
              <AccordionContent className="text-base text-muted-foreground font-sans pb-6 leading-relaxed">
                {item.answer}
              </AccordionContent>
            </AccordionItem>)}
        </Accordion>
      </div>
    </section>;
}